var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('input',{staticClass:"btn btn-secondary btn-lg submit-button",attrs:{"type":"submit","disabled":_vm.disabled},domProps:{"value":_vm.label},on:{"click":_vm.submitClicked}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }